// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Users_establishments__22F-C","header":"Users_header__2fOry","tableHeader":"Users_tableHeader__1iiOj"};